export const firebaseConfig = {
    apiKey: "AIzaSyDz9fkJpy2xLAq-xIOxJ2zR-9D335AcEbc",
    authDomain: "gamingproject-1337b.firebaseapp.com",
    databaseURL: "https://gamingproject-1337b.firebaseio.com",
    projectId: "gamingproject-1337b",
    storageBucket: "gamingproject-1337b.appspot.com",
    messagingSenderId: "93223299990"
};


// WEBPACK FOOTER //
// ./src/app/config/firebase.config.ts